/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit CardMessageNoAvatar/view.blocks to change it.
import Children from 'Simple/Children'
import React from 'react'
import styles from './view.module.css'
import useIsMedia from 'Simple/hooks/useIsMedia'



/** @type {import('Simple/types.js').View} */
export default function CardMessageNoAvatar({
  children,
  viewPath = "/DesignSystem/CardMessageNoAvatar",
  alignSelf = "flex-end",
  alignItems = "flex-end",
  marginTop = 8,
  marginBottom = 0,
  paddingTop = 12,
  paddingBottom = 16,
  paddingLeft = 16,
  paddingRight = 16,
  backgroundColor = "#e6e6e6",
  marginLeft = 0,
  marginRight = 0,
  maxWidth = 400,
  zIndex
  
}) {
  let isMedia = useIsMedia()
  return (<React.Fragment
>
<div
  data-testid="CardMessageNoAvatar.Vertical"
  data-view-path={viewPath}
 style={{'--as-1-1ED2Tc': alignSelf,'--ai-2-1ED2Tc': alignItems,'--mt-3-1ED2Tc': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-4-1ED2Tc': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--bc-9-1ED2Tc': backgroundColor,'--zi-14-1ED2Tc': zIndex,'--pt-5-1ED2Tc': isMedia.mobile ? "4px" : typeof paddingTop === 'number' ? `${paddingTop}px` : paddingTop,'--pb-6-1ED2Tc': isMedia.mobile ? "4px" : typeof paddingBottom === 'number' ? `${paddingBottom}px` : paddingBottom,'--pl-7-1ED2Tc': isMedia.mobile ? "4px" : typeof paddingLeft === 'number' ? `${paddingLeft}px` : paddingLeft,'--pr-8-1ED2Tc': isMedia.mobile ? "4px" : typeof paddingRight === 'number' ? `${paddingRight}px` : paddingRight,'--ml-10-1ED2Tc': isMedia.mobile ? "4px" : typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-11-1ED2Tc': isMedia.mobile ? "4px" : typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--mw-12-1ED2Tc': isMedia.mobile ? "100%" : typeof maxWidth === 'number' ? `${maxWidth}px` : maxWidth,'--fw-13-1ED2Tc': isMedia.mobile ? "nowrap" : "wrap"}}
 className={`views-block ${styles.Vertical}`}
>
<Children
  viewPath={`${viewPath}/Children`}
>
{children}
</Children>
</div>
</React.Fragment>)
}